import React from 'react';
import { Link } from 'react-router-dom';
import FilterIcon from '../icons/filter';
import Logo from '../icons/logo';

export default function Header() {
  return (
    <header className="ruter-white-on-red ruter-header">
      <Logo className="logo" />
      <h1>Vehicle Status</h1>
      <hr className="spacing" />
      <Link to="/" className="filter-link">
        <FilterIcon className="icon" />
      </Link>
    </header>
  );
}
